import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

const TextInput = ({ label, value, className })=>{
    return jsxs("div", {
        className: classNames('cb-input', 'cb-text-input', className),
        "data-testid": "text-input-container",
        children: [
            jsx("p", {
                className: classNames('message', 'ti-variant-primary'),
                "data-testid": "label",
                children: label
            }),
            jsx("p", {
                className: classNames('text', 'ti-variant-primary'),
                "data-testid": "value",
                children: value
            })
        ]
    });
};
TextInput.displayName = 'TextInput';

export { TextInput, TextInput as default };
//# sourceMappingURL=TextInput.es.js.map
